<template>
  <BaseModal
    name="pixel-fb"
    size="lg"
    :title="$t('seller.products.pixelfb.text_653')"
    @shown="openModal"
    @hidden="reset"
  >
    <!-- Loading -->
    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <section class="container-pixel" v-else>
      <b-form novalidate v-show="step == 1">
        <!-- Imagem -->
        <img :src="iconeType" class="mb-4" :class="{'ga4': this.type_pixel.toLowerCase() === 'ga4'}" />
        <!-- Id Pixel -->
        <b-form-group label="ID Pixel" label-for="pixel_id">
          <b-form-input
            id="pixel_id"
            name="pixel_id"
            type="text"
            autocomplete="off"
            v-model.trim="pixel.pixel_id"
            :placeholder="cPlaceholderPixel"
            v-validate="'required'"
          ></b-form-input>
          <b-form-invalid-feedback :state="!errors.has('pixel_id')">
            {{ $t('seller.products.pixelfb.text_654') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <!-- Label Conversion -->
        <b-form-group
          v-if="type_pixel === 'GOOGLEADWORDS'"
          :label="$t('seller.products.pixelfb.text_655')"
          label-for="label_conversion"
          class="mt-4"
        >
          <b-form-input
            id="label_conversion"
            name="label_conversion"
            type="text"
            :placeholder="$t('seller.products.pixelfb.text_655')"
            autocomplete="off"
            v-model="pixel.label"
          ></b-form-input>
        </b-form-group>
        <!-- Events you like to receive -->
        <b-form-group
          class="mt-4"
          id="events_pixel"
          :label="$t('seller.products.pixelfb.text_656')"
          label-for="events_pixel"
          data-anima="top"
          v-show="pixel.pixel_id"
        >
          <template v-if="type_pixel === 'FACEBOOK'">
            <!-- Todos Eventos do Checkout (PageView) -->
            <b-form-checkbox
              class="mt-3"
              name="events_pixel"
              v-model="pixel.page_view"
              size="lg"
              switch
            >
              <p class="info-checkbox">
                {{ $t('seller.products.pixelfb.text_707') }}
                <span class="descricao-checkbox">
                  {{ $t('seller.products.pixelfb.text_708') }}
                </span>
              </p>
            </b-form-checkbox>
            <!-- Visitas em Checkout (ViewContent) -->
            <b-form-checkbox
              class="mt-3"
              name="events_pixel"
              v-model="pixel.view_content"
              size="lg"
              switch
            >
              <p class="info-checkbox">
               {{ $t('seller.products.pixelfb.text_657') }}
                <span class="descricao-checkbox">
                  {{ $t('seller.products.pixelfb.text_658') }}
                </span>
              </p>
            </b-form-checkbox>
            <!-- Preencheu os Dados no Pessoais (InitiateCheckout) -->
            <b-form-checkbox
              class="my-3 custom-align"
              name="events_pixel"
              v-model="pixel.initiate_checkout"
              size="lg"
              switch
            >
              <p class="info-checkbox alinhamento-sem-descricao">
                {{ $t('seller.products.pixelfb.text_709') }}
              </p>
            </b-form-checkbox>
            <template v-if="pixel.initiate_checkout">
              <div class="d-flex">
                <div class="custom-card-pixel">
                  <div class="d-flex justify-content-between">
                    <div class="mb-2">
                      <p class="info-checkbox pixel-card">{{ $t('seller.products.pixelfb.text_711') }}</p>
                    </div>
                    <div>
                      <b-form-radio
                        v-model="pixel.initiate_checkout_event"
                        name="initiate_checkout_event"
                        value="on_access"
                      ></b-form-radio>
                    </div>
                  </div>
                  <span class="descricao-checkbox">
                    {{ $t('seller.products.pixelfb.text_712') }}
                  </span>
                </div>
                <div class="custom-card-pixel">
                  <div class="d-flex justify-content-between">
                    <div class="mb-2">
                      <p class="info-checkbox pixel-card">{{ $t('seller.products.pixelfb.text_713') }}</p>
                    </div>
                    <div>
                      <b-form-radio
                        v-model="pixel.initiate_checkout_event"
                        name="initiate_checkout_event"
                        value="on_filled_data"
                      ></b-form-radio>
                    </div>
                  </div>
                  <span class="descricao-checkbox">
                    {{ $t('seller.products.pixelfb.text_714') }}
                  </span>
                  <div class="d-flex justify-content-end">
                    <div class="recomendation-chip">{{ $t('seller.products.pixelfb.text_745') }}</div>
                  </div>
                </div>
              </div>
              <hr class="my-3">
            </template>
            <!-- Preencher os Dados Pagamento (AddPaymentInfo) -->
            <b-form-checkbox
              class="mt-3"
              name="events_pixel"
              v-model="pixel.add_payment_info"
              size="lg"
              switch
            >
              <p class="info-checkbox">
                {{ $t('seller.products.pixelfb.text_715') }}
                <span class="descricao-checkbox">
                  {{ $t('seller.products.pixelfb.text_716') }}
                </span>
              </p>
            </b-form-checkbox>
            <!-- Selecionou o Produto (AddToCart) -->
            <b-form-checkbox
              class="my-3 custom-align"
              name="events_pixel"
              v-model="pixel.add_to_cart"
              size="lg"
              switch
            >
              <p class="info-checkbox alinhamento-sem-descricao">
                {{ $t('seller.products.pixelfb.text_717') }}
              </p>
            </b-form-checkbox>
            <template v-if="pixel.add_to_cart">
              <div class="d-flex">
                <div class="custom-card-pixel">
                  <div class="d-flex justify-content-between">
                    <div class="mb-2">
                      <p class="info-checkbox pixel-card">{{ $t('seller.products.pixelfb.text_721') }}</p>
                    </div>
                    <div>
                      <b-form-checkbox
                        v-model="pixel.on_main_product"
                        name="on_main_product"
                        size="md"
                      ></b-form-checkbox>
                    </div>
                  </div>
                  <span class="descricao-checkbox">
                    {{ $t('seller.products.pixelfb.text_722') }}
                  </span>
                </div>
                <div class="custom-card-pixel">
                  <div class="d-flex justify-content-between">
                    <div class="mb-2">
                      <p class="info-checkbox pixel-card">{{ $t('seller.products.pixelfb.text_723') }}</p>
                    </div>
                    <div>
                      <b-form-checkbox
                        v-model="pixel.on_orderbump"
                        name="on_orderbump"
                        size="md"
                      ></b-form-checkbox>
                    </div>
                  </div>
                  <span class="descricao-checkbox">
                    {{ $t('seller.products.pixelfb.text_724') }}
                  </span>
                </div>
              </div>
              <hr class="my-3">
            </template>
            <!-- Conversão de vendas (Purchase) -->
            <b-form-checkbox
              class="my-3 custom-align"
              name="events_pixel"
              v-model="pixel.conversion"
              size="lg"
              switch
            >
              <p class="info-checkbox alinhamento-sem-descricao">
                {{ $t('seller.products.pixelfb.text_725') }}
              </p>
            </b-form-checkbox>
            <template v-if="pixel.conversion">
              <b-form-group>
                <div class="d-flex">
                  <div class="custom-card-pixel">
                    <div class="d-flex justify-content-between">
                      <div class="mb-2">
                        <p class="info-checkbox pixel-card">{{ $t('seller.products.pixelfb.text_727') }}</p>
                      </div>
                      <div>
                        <b-form-radio
                          v-model="pixel.conversion_event"
                          name="conversion_event"
                          value="on_payment_try"
                        ></b-form-radio>
                      </div>
                    </div>
                    <span class="descricao-checkbox">
                      {{ $t('seller.products.pixelfb.text_728') }}
                    </span>
                  </div>
                  <div class="custom-card-pixel">
                    <div class="d-flex justify-content-between">
                      <div class="mb-2">
                        <p class="info-checkbox pixel-card">{{ $t('seller.products.pixelfb.text_729') }}</p>
                      </div>
                      <div>
                        <b-form-radio
                          v-model="pixel.conversion_event"
                          name="conversion_event"
                          value="on_payment_success"
                        ></b-form-radio>
                      </div>
                    </div>
                    <span class="descricao-checkbox">
                      {{ $t('seller.products.pixelfb.text_730') }}
                    </span>
                  </div>
                </div>
                <div class="d-flex">
                  <div class="custom-card-pixel">
                    <div class="d-flex justify-content-between">
                      <div class="mb-2">
                        <p class="info-checkbox pixel-card">{{ $t('seller.products.pixelfb.text_731') }}</p>
                      </div>
                      <div>
                        <b-form-radio
                          v-model="pixel.conversion_event"
                          name="conversion_event"
                          value="on_payment_paid"
                        ></b-form-radio>
                      </div>
                    </div>
                    <span class="descricao-checkbox">
                      {{ $t('seller.products.pixelfb.text_732') }}
                    </span>
                  </div>
                </div>
              </b-form-group>
              <hr class="my-3">
            </template>
            <!-- Conversão de vendas OrderBump (OrderBumpPurchase) -->
            <b-form-checkbox
              class="my-3 custom-align"
              name="events_pixel"
              v-model="pixel.orderbump_purchase"
              size="lg"
              switch
            >
              <p class="info-checkbox alinhamento-sem-descricao">
                {{ $t('seller.products.pixelfb.text_733') }}
              </p>
            </b-form-checkbox>
            <template v-if="pixel.orderbump_purchase">
              <b-form-group> 
                <div class="d-flex">
                  <div class="custom-card-pixel">
                    <div class="d-flex justify-content-between">
                      <div class="mb-2">
                        <p class="info-checkbox pixel-card">{{ $t('seller.products.pixelfb.text_735') }}</p>
                      </div>
                      <div>
                        <b-form-radio
                          v-model="pixel.orderbump_purchase_event"
                          name="orderbump_purchase_event"
                          value="on_payment_try"
                        ></b-form-radio>
                      </div>
                    </div>
                    <span class="descricao-checkbox">
                      {{ $t('seller.products.pixelfb.text_736') }}
                    </span>
                  </div>
                  <div class="custom-card-pixel">
                    <div class="d-flex justify-content-between">
                      <div class="mb-2">
                        <p class="info-checkbox pixel-card">{{ $t('seller.products.pixelfb.text_737') }}</p>
                      </div>
                      <div>
                        <b-form-radio
                          v-model="pixel.orderbump_purchase_event"
                          name="orderbump_purchase_event"
                          value="on_payment_success"
                        ></b-form-radio>
                      </div>
                    </div>
                    <span class="descricao-checkbox">
                      {{ $t('seller.products.pixelfb.text_738') }}
                    </span>
                  </div>
                </div>
                <div class="d-flex">
                  <div class="custom-card-pixel">
                    <div class="d-flex justify-content-between">
                      <div class="mb-2">
                        <p class="info-checkbox pixel-card">{{ $t('seller.products.pixelfb.text_739') }}</p>
                      </div>
                      <div>
                        <b-form-radio
                          v-model="pixel.orderbump_purchase_event"
                          name="orderbump_purchase_event"
                          value="on_payment_paid"
                        ></b-form-radio>
                      </div>
                    </div>
                    <span class="descricao-checkbox">
                      {{ $t('seller.products.pixelfb.text_740') }}
                    </span>
                  </div>
                </div>
              </b-form-group>
              <hr class="my-3">
            </template>
            <!-- Início de um Trial (StartTrial) -->
            <b-form-checkbox
              class="mt-3"
              name="events_pixel"
              v-model="pixel.start_trial"
              size="lg"
              switch
            >
              <p class="info-checkbox">
                {{ $t('seller.products.pixelfb.text_741') }}
                <span class="descricao-checkbox">
                  {{ $t('seller.products.pixelfb.text_742') }}
                </span>
              </p>
            </b-form-checkbox>
            <!-- Início de uma Assinatura Paga (Subscribe) -->
            <b-form-checkbox
              class="mt-3"
              name="events_pixel"
              v-model="pixel.subscribe"
              size="lg"
              switch
            >
              <p class="info-checkbox">
                {{ $t('seller.products.pixelfb.text_743') }}
                <span class="descricao-checkbox">
                  {{ $t('seller.products.pixelfb.text_744') }}
                </span>
              </p>
            </b-form-checkbox>
          </template>
          <template v-else>
            <!-- Visitas ao Checkout -->
            <b-form-checkbox
              class="mt-3"
              name="events_pixel"
              v-model="pixel.view"
              size="lg"
              switch
            >
              <p class="info-checkbox">
              {{ $t('seller.products.pixelfb.text_657_1') }}
                <span class="descricao-checkbox">
                  {{ $t('seller.products.pixelfb.text_658_1') }}
                </span>
              </p>
            </b-form-checkbox>
            <!-- Conversão de Vendas -->
            <b-form-checkbox
              class="mt-3"
              name="events_pixel"
              v-model="pixel.conversion"
              size="lg"
              switch
            >
              <p class="info-checkbox">
                {{ $t('seller.products.pixelfb.text_659') }}
                <span class="descricao-checkbox">
                  {{ $t('seller.products.pixelfb.text_660') }}
                </span>
              </p>
            </b-form-checkbox>
          </template>
        </b-form-group>
        <!-- Advenced Configs -->
        <div v-if="pixel.pixel_id && pixel.conversion">
          <span
            data-anima="top"
            class="collapse-item collapse-arrow"
            v-b-toggle.collapse-pixel
            :class="{ ativo: collapse }"
            @click="collapse = !collapse"
          >
            {{ $t('seller.products.pixelfb.text_661') }}
            <img src="@/assets/img/icons/arrow-fill.svg" />
          </span>

          <b-collapse id="collapse-pixel" data-anima="top" class="mt-3">
            <!-- Receber confirmação de venda de qual meio de pagamento? -->
            <b-form-group
              v-if="type_pixel !== 'FACEBOOK'"
              class="mb-3"
              :label="$t('seller.products.pixelfb.text_662')"
              v-slot="{ ariaDescribedby }"
            >
              <b-form-radio-group
                class="mt-1"
                id="radio-group-1"
                v-model="pixel.confirmed_only"
                :options="options_pagamento"
                :aria-describedby="ariaDescribedby"
                name="radio-options"
                stacked
              ></b-form-radio-group>
            </b-form-group>

            <div>
              <b-form-checkbox
                class="mt-3"
                name="events_pixel"
                v-model="pixel.web"
                size="lg"
                switch
              >
                <p class="info-checkbox">
                  {{ $t('seller.products.pixelfb.text_663') }}
                  <div class="d-flex justify-content-between">
                    <span class="descricao-checkbox">
                      {{ $t('seller.products.pixelfb.text_664') }}
                    </span>
                    <div class="recomendation-chip">{{ $t('seller.products.pixelfb.text_745') }}</div>
                  </div>
                </p>
              </b-form-checkbox>

              <b-form-checkbox
                v-show="type_pixel === 'FACEBOOK'"
                class="mt-3"
                name="events_pixel"
                v-model="pixel.api"
                size="lg"
                switch
              >
                <p class="info-checkbox">
                  {{ $t('seller.products.pixelfb.text_665') }}
                  <div class="d-flex justify-content-between">
                    <span class="descricao-checkbox">
                      {{ $t('seller.products.pixelfb.text_666') }}
                    </span>
                    <div class="recomendation-chip">{{ $t('seller.products.pixelfb.text_745') }}</div>
                  </div>
                </p>
              </b-form-checkbox>

              <b-form-checkbox
                v-show="type_pixel === 'FACEBOOK'"
                class="mt-3"
                name="events_pixel"
                v-model="pixel.amount"
                size="lg"
                switch
              >
                <p class="info-checkbox">
                  {{ $t('seller.products.pixelfb.text_699') }}
                  <span class="descricao-checkbox">{{ $t('seller.products.pixelfb.text_700') }}</span>
                </p>
              </b-form-checkbox>

              <b-form-group
                :label="$t('seller.products.pixelfb.text_667')"
                label-for="token"
                v-if="pixel.api"
                data-anima="top"
                class="mt-3"
              >
                <b-form-input
                  id="token"
                  name="token"
                  type="text"
                  autocomplete="off"
                  v-model="pixel.token"
                  :placeholder="$t('seller.products.pixelfb.text_667')"
                  v-validate="'required'"
                ></b-form-input>
                <b-form-invalid-feedback :state="!errors.has('token')">
                  {{ $t('seller.products.pixelfb.text_668') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </b-collapse>
        </div>
      </b-form>
      <b-form v-if="step == 2">
        <!-- Cadastrar Domínio -->
        <div data-anima="bottom">
          <b-form-group
            :label="$t('seller.products.pixelfb.text_669')"
            v-slot="{ ariaDescribedby }"
          >
            <p class="mini-info">
              {{ $t('seller.products.pixelfb.text_670') }} {{ type_pixel }}, {{ $t('seller.products.pixelfb.text_671') }} <span>{{ $t('seller.products.pixelfb.text_672') }}</span>
            </p>
            <b-form-radio-group
              class="mt-3 mr-3"
              id="radio-group-2"
              v-model="has_domain"
              :options="options_domain"
              :aria-describedby="ariaDescribedby"
              name="radio-options"
            ></b-form-radio-group>
          </b-form-group>
        </div>

        <div v-if="has_domain == 'true'" class="mt-3" data-anima="top">
          <b-form-group :label="$t('seller.products.pixelfb.text_673')">
            <ul class="steps">
              <!-- Informe o Domínio -->
              <li>
                <span>01.</span>
                <div>
                  <p>
                    {{ $t('seller.products.pixelfb.text_674') }}
                    <b>{{ $t('seller.products.pixelfb.text_675') }} {{ type_pixel }}.</b>
                  </p>
                  <span class="mini-info">
                    {{ $t('seller.products.pixelfb.text_676') }}
                  </span>
                  <div class="mt-2">
                    <b-form-input
                      id="domain"
                      name="domain"
                      type="text"
                      autocomplete="off"
                      v-model="pixel.domain.domain"
                      placeholder="Ex: seudominio.com.br"
                      v-validate="'required'"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="!errors.has('domain')">
                      {{ $t('seller.products.pixelfb.text_677') }}
                    </b-form-invalid-feedback>
                  </div>
                </div>
              </li>
              <!-- CNAME do Domínio -->
              <li>
                <span>02.</span>
                <div>
                  <p>{{ $t('seller.products.pixelfb.text_678') }}</p>
                  <span class="mini-info">
                    {{ $t('seller.products.pixelfb.text_679') }} {{ type_pixel }} {{ $t('seller.products.pixelfb.text_680') }}
                  </span>
                  <ul class="instrucoes">
                    <li>
                      <p>
                        a. {{ $t('seller.products.pixelfb.text_681') }}
                      </p>
                    </li>
                    <li>
                      <p>
                        b. {{ $t('seller.products.pixelfb.text_682') }}
                        <b v-if="pixel && pixel.domain && pixel.domain.domain"
                          >greenn.{{ pixel.domain.domain }}</b
                        >
                        <b v-else>greenn.meudominio.com.br</b> {{ $t('seller.products.pixelfb.text_683') }}
                        <b>pixel.greenn.com.br</b>
                      </p>
                    </li>
                    <li><p>c. {{ $t('seller.products.pixelfb.text_684') }}</p></li>
                    <li>
                      <p>d. {{ $t('seller.products.pixelfb.text_685') }}</p>
                      <span class="mini-info">
                        {{ $t('seller.products.pixelfb.text_686') }}
                      </span>
                      <div class="status" :class="{ ativada: pixel.dns }">
                        CNAME
                        {{ pixel.dns ? $t('seller.products.pixelfb.text_688') : $t('seller.products.pixelfb.text_689') }}
                      </div>
                      <div class="status" :class="{ ativada: pixel.ssl }">
                        {{ $t('seller.products.pixelfb.text_687') }}
                        {{ pixel.ssl ? $t('seller.products.pixelfb.text_688') : $t('seller.products.pixelfb.text_689') }}
                      </div>
                    </li>
                    <li>
                      <p>
                        e. {{ $t('seller.products.pixelfb.text_690') }}
                        {{ type_pixel }}.
                      </p>
                      <span class="mini-info">
                        {{ $t('seller.products.pixelfb.text_691') }}
                        {{ type_pixel }} {{ $t('seller.products.pixelfb.text_692') }}</span>
                      <b-form-group
                        class="mt-4 mb-3"
                        id="optimization_pixel"
                        label=""
                        label-for="optimization_pixel"
                        data-anima="top"
                      >
                        <b-form-checkbox
                          class="mt-3"
                          name="optimization_pixel"
                          v-model="pixel.optimization"
                          size="lg"
                          switch
                          :disabled="!pixel.dns && !pixel.ssl"
                        >
                          <p class="info-checkbox">{{ $t('seller.products.pixelfb.text_693') }}</p>
                        </b-form-checkbox>
                      </b-form-group>
                    </li>
                  </ul>
                  <span class="mini-info">
                    {{ $t('seller.products.pixelfb.text_694') }}
                  </span>
                </div>
              </li>
            </ul>
          </b-form-group>
        </div>
      </b-form>
    </section>

    <template v-slot:footer>
      <BaseButton
        :disabled="loading"
        variant="link-info"
        class="mr-3"
        @click="back"
      >
        {{ step == 1 ? $t('seller.products.pixelfb.text_701') : $t('seller.products.pixelfb.text_702') }}
      </BaseButton>
      <div v-if="pixel.pixel_id" data-anima="right">
        <BaseButton variant="black" @click="next">
          {{ step == 1 ? $t('seller.products.pixelfb.text_703') : $t('seller.products.pixelfb.text_704') }}
        </BaseButton>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import ConversionPixelService from "@/services/resources/ConversionPixelService";
const serviceConversionPixel = ConversionPixelService.build();

export default {
  props: {
    product_id: {
      type: Number,
      default: -1,
    },
    type_pixel: {
      type: String,
      default: "FACEBOOK",
    },
    pixel_edit: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      collapse: false,
      step: 1,
      placeholderPixel: {
        FACEBOOK: "Ex: 1234567890",
        GOOGLEADWORDS: "Ex: AW-0000000000",
        GOOGLETAGMANAGER: "Ex: GTM-XXXXXXX",
        GOOGLEANALYTICS: "Ex: UA-000000-00",
        GA4: "Ex: G-XXXXXXXX",
        TIKTOK: "Ex: 1234567890",
      },
      pixel: {
        pixel_id: "",
        product_id: -1,
        type: "",
        confirmed_only: 0,
        web: true,
        api: false,
        amount: false,
        token: "",
        domain: {
          domain: "",
        },
        page_view: true,
        view_content: true,
        initiate_checkout: true,
        initiate_checkout_event: 'on_access',
        add_payment_info: true,
        add_to_cart: true,
        on_main_product: true,
        on_orderbump: true,
        conversion: true,
        conversion_event: 'on_payment_paid',
        orderbump_purchase: true,
        orderbump_purchase_event: 'on_payment_paid',
        start_trial: true,
        subscribe: true,
      },
      pixelConfigs: [],
      pixel_request: {},
      options_pagamento: [
        { text: this.$t('seller.products.pixelfb.text_695'), value: 0 },
        { text: this.$t('seller.products.pixelfb.text_696'), value: 1 },
      ],
      has_domain: null,
      options_domain: [
        { text: this.$t('seller.products.pixelfb.text_705'), value: "true" },
        { text: this.$t('seller.products.pixelfb.text_706'), value: "false" },
      ],
    };
  },

  computed: {
    iconeType() {
      if (this.type_pixel) {
        return require(`@/assets/img/${this.type_pixel.toLowerCase()}_icone.png`);
      } else return false;
    },
    cPlaceholderPixel() {
      return this.placeholderPixel[this.type_pixel] || "";
    },
  },
  methods: {
    back() {
      if (this.step == 2) {
        this.step = 1;
      } else {
        this.$bvModal.hide("pixel-fb");
      }
    },
    next() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          if (this.step == 1) {
            this.step = 2;
          } else {
            this.formatObjectPixel();
          }
        }
      });
    },
    formatObjectPixel() {
      this.pixel_request = {
        pixel_id: this.pixel.pixel_id,
        product_id: this.product_id,
        type: !this.pixel.type || this.pixel.type == '' ? this.type_pixel : this.pixel.type,
        web: this.pixel.web ? 1 : 0,
        api: this.pixel.api ? 1 : 0,
        confirmed_only: this.pixel.confirmed_only ? 1 : 0,
        token: this.pixel.token,
        domain: this.pixel.domain.domain,
        conversion: this.pixel.conversion ? 1 : 0,
        view: this.pixel.view ? 1 : 0,
        optimization: this.pixel.optimization ? 1 : 0
      };

      if (this.type_pixel === "GOOGLEADWORDS" && this.pixel.label) {
        this.pixel_request.label = this.pixel.label;
      }

      if (this.type_pixel != "FACEBOOK") {
        this.pixel_request.api = 0;
        this.pixel_request.token = "";
      }

      if (this.type_pixel == "FACEBOOK") {
        this.pixel_request.amount = this.pixel.amount ? 1 : 0;
        this.pixel_request.configs = [
          {
            id: this.pixelConfigs.some(x => x.event === 'PageView') ? (this.pixelConfigs.find(x => x.event === 'PageView')).id : null,
            event: 'PageView',
            action: null,
            isActive: this.pixel.page_view ? 1 : 0
          },
          {
            id: this.pixelConfigs.some(x => x.event === 'ViewContent') ? (this.pixelConfigs.find(x => x.event === 'ViewContent')).id : null,
            event: 'ViewContent',
            action: null,
            isActive: this.pixel.view_content ? 1 : 0
          },
          {
            id: this.pixelConfigs.some(x => x.event === 'InitiateCheckout') ? (this.pixelConfigs.find(x => x.event === 'InitiateCheckout')).id : null,
            event: 'InitiateCheckout',
            action: this.pixel.initiate_checkout_event,
            isActive: this.pixel.initiate_checkout ? 1 : 0
          },
          {
            id: this.pixelConfigs.some(x => x.event === 'AddPaymentInfo') ? (this.pixelConfigs.find(x => x.event === 'AddPaymentInfo')).id : null,
            event: 'AddPaymentInfo',
            action: null,
            isActive: this.pixel.add_payment_info ? 1 : 0
          },
          {
            id: this.pixelConfigs.some(x => x.event === 'AddToCart' && x.action === 'on_main_product') ? (this.pixelConfigs.find(x => x.event === 'AddToCart' && x.action === 'on_main_product')).id : null,
            event: 'AddToCart',
            action: 'on_main_product',
            isActive: (this.pixel.add_to_cart && this.pixel.on_main_product) ? 1 : 0
          },
          {
            id: this.pixelConfigs.some(x => x.event === 'AddToCart' && x.action === 'on_orderbump') ? (this.pixelConfigs.find(x => x.event === 'AddToCart' && x.action === 'on_orderbump')).id : null,
            event: 'AddToCart',
            action: 'on_orderbump',
            isActive: (this.pixel.add_to_cart && this.pixel.on_orderbump) ? 1 : 0
          },
          {
            id: this.pixelConfigs.some(x => x.event === 'Purchase') ? (this.pixelConfigs.find(x => x.event === 'Purchase')).id : null,
            event: 'Purchase',
            action: this.pixel.conversion_event,
            isActive: this.pixel.conversion ? 1 : 0
          },
          {
            id: this.pixelConfigs.some(x => x.event === 'OrderBumpPurchase') ? (this.pixelConfigs.find(x => x.event === 'OrderBumpPurchase')).id : null,
            event: 'OrderBumpPurchase',
            action: this.pixel.orderbump_purchase_event,
            isActive: this.pixel.orderbump_purchase ? 1 : 0
          },
          {
            id: this.pixelConfigs.some(x => x.event === 'StartTrial') ? (this.pixelConfigs.find(x => x.event === 'StartTrial')).id : null,
            event: 'StartTrial',
            action: null,
            isActive: this.pixel.start_trial ? 1 : 0
          },
          {
            id: this.pixelConfigs.some(x => x.event === 'Subscribe') ? (this.pixelConfigs.find(x => x.event === 'Subscribe')).id : null,
            event: 'Subscribe',
            action: null,
            isActive: this.pixel.subscribe ? 1 : 0
          }
        ]
      }

      this.onSubmit();
    },
    atualizaPixel() {
      this.loading = true;
      let data = {
        id: this.pixel.id,
        ...this.pixel_request,
      };
      serviceConversionPixel
        .update(data)
        .then(() => {
          this.$bvToast.toast(this.$t('seller.products.pixelfb.text_697'), {
            title: "Pixel",
            variant: "success",
            autoHideDelay: 5000,
            appendToast: true,
          });
          this.$emit("close", true);
          this.$bvModal.hide("pixel-fb");
          this.reset();
        })
        .catch((err) =>  console.error(err))
        .finally(() => { this.loading = false })
    },
    onSubmit() {
      if (this.pixel_edit.edit) {
        this.atualizaPixel();
      } else {
        this.loading = true;
        serviceConversionPixel
          .create(this.pixel_request)
          .then(() => {
            this.$bvToast.toast(this.$t('seller.products.pixelfb.text_698'), {
              title: "Pixel",
              variant: "success",
              autoHideDelay: 5000,
              appendToast: true,
            });
            this.$emit("close", true);
            this.$bvModal.hide("pixel-fb");
            this.reset();
          })
          .catch((err) => console.error(err))
          .finally(() => { this.loading = false })
      }
    },
    openModal() {
      this.loading = true;

      if (this.pixel_edit.edit) {
        this.pixel = {
          id: this.pixel_edit.item.id,
          pixel_id: this.pixel_edit.item.pixel_id,
          product_id: this.product_id,
          type: this.pixel_edit.item.type,
          label: this.pixel_edit.item.label,
          dns: this.pixel_edit.item.dns,
          ssl: this.pixel_edit.item.ssl,
          confirmed_only: this.pixel_edit.item.confirmed_only ? 1 : 0,
          web: this.pixel_edit.item.web ? true : false,
          api: this.pixel_edit.item.api ? true : false,
          amount: this.pixel_edit.item.amount ? true : false,
          token: this.pixel_edit.item.token,
          domain: this.pixel_edit.item.domain
            ? this.pixel_edit.item.domain
            : [],
          optimization: this.pixel_edit.item.optimization ? true : false,
          page_view: true,
          view: this.pixel_edit.item.view ? true : false,
          view_content: true,
          initiate_checkout: true,
          initiate_checkout_event: 'on_filled_data',
          add_payment_info: true,
          add_to_cart: true,
          on_main_product: true,
          on_orderbump: true,
          conversion: this.pixel_edit.item.conversion ? true : false,
          conversion_event: 'on_payment_paid',
          orderbump_purchase: true,
          orderbump_purchase_event: 'on_payment_paid',
          start_trial: true,
          subscribe: true,
        };
        if(this.pixel_edit.item.pixel_configuration && this.pixel_edit.item.pixel_configuration.length) {
          this.pixelConfigs = this.pixel_edit.item.pixel_configuration
          
          this.pixel.page_view = this.pixel_edit.item.pixel_configuration.some(x => x.is_active && x.event === 'PageView') ? true : false
          this.pixel.view_content = this.pixel_edit.item.pixel_configuration.some(x => x.is_active && x.event === 'ViewContent')
          this.pixel.initiate_checkout = this.pixel_edit.item.pixel_configuration.some(x => x.is_active && x.event === 'InitiateCheckout')
          this.pixel.initiate_checkout_event = this.pixel_edit.item.pixel_configuration.some(x => x.is_active && x.event === 'InitiateCheckout') ? (this.pixel_edit.item.pixel_configuration.find(x => x.is_active && x.event === 'InitiateCheckout')).action : 'on_access'
          this.pixel.add_payment_info = this.pixel_edit.item.pixel_configuration.some(x => x.is_active && x.event === 'AddPaymentInfo')
          this.pixel.add_to_cart = this.pixel_edit.item.pixel_configuration.some(x => x.is_active && x.event === 'AddToCart')
          this.pixel.on_main_product = this.pixel_edit.item.pixel_configuration.some(x => x.is_active && x.event === 'AddToCart' && x.action === 'on_main_product')
          this.pixel.on_orderbump = this.pixel_edit.item.pixel_configuration.some(x => x.is_active && x.event === 'AddToCart' && x.action === 'on_orderbump')
          this.pixel.conversion = this.pixel_edit.item.pixel_configuration.some(x => x.is_active && x.event === 'Purchase')
          this.pixel.conversion_event = this.pixel_edit.item.pixel_configuration.some(x => x.is_active && x.event === 'Purchase') ? (this.pixel_edit.item.pixel_configuration.find(x => x.is_active && x.event === 'Purchase')).action : 'on_payment_paid'
          this.pixel.orderbump_purchase = this.pixel_edit.item.pixel_configuration.some(x => x.is_active && x.event === 'OrderBumpPurchase')
          this.pixel.orderbump_purchase_event = this.pixel_edit.item.pixel_configuration.some(x => x.is_active && x.event === 'OrderBumpPurchase') ? (this.pixel_edit.item.pixel_configuration.find(x => x.is_active && x.event === 'OrderBumpPurchase')).action : 'on_payment_paid'
          this.pixel.start_trial = this.pixel_edit.item.pixel_configuration.some(x => x.is_active && x.event === 'StartTrial')
          this.pixel.subscribe = this.pixel_edit.item.pixel_configuration.some(x => x.is_active && x.event === 'Subscribe')
        } else {
          this.pixel.initiate_checkout_event = 'on_access'
          this.pixel.conversion_event = 'on_payment_success'
          this.pixel.orderbump_purchase_event = 'on_payment_success'
        }

        if (this.pixel.domain && this.pixel.domain.domain) {
          this.has_domain = "true";
        } else {
          this.has_domain = "false";
        }
      } else {
        this.reset();
      }
      this.loading = false;
    },
    reset() {
      this.pixel = {
        pixel_id: "",
        product_id: -1,
        type: "",
        confirmed_only: 0,
        web: true,
        api: false,
        amount: false,
        token: "",
        domain: {
          domain: "",
        },
        page_view: true,
        view_content: true,
        initiate_checkout: true,
        initiate_checkout_event: 'on_filled_data',
        add_payment_info: true,
        add_to_cart: true,
        on_main_product: true,
        on_orderbump: true,
        conversion: true,
        view: true,
        conversion_event: 'on_payment_paid',
        orderbump_purchase: true,
        orderbump_purchase_event: 'on_payment_paid',
        start_trial: true,
        subscribe: true,
      };

      this.has_domain = null;
      this.collapse = false;
      this.step = 1;
      this.$emit("close", false);
    },
  },
};
</script>

<style lang="scss" scoped>
#pixel_id {
  width: 300px;
}
.info-checkbox {
  cursor: pointer;
}
.info-checkbox span {
  font-size: 12px;
}
.descricao-checkbox {
  margin-left: 0 !important;
  max-width: none;
}
.collapse-item {
  margin-top: 30px;
  font-size: 13px;
  color: var(--blue-500);
  padding: 15px 20px;
  border: 1px solid var(--gray-50);
  border-radius: 5px;
}
// collapse
.collapse-arrow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
}
.collapse-arrow.ativo {
  margin-bottom: 15px;
  color: var(--old-800);
  border-bottom-color: transparent;
}
.collapse-arrow.ativo img {
  transition: 0.3s;
  transform: rotate(180deg);
}
.mini-info {
  color: var(--gray-200) !important;
  font-size: 12px !important;
  font-weight: normal !important;
}
.mini-info span {
  font-weight: 600;
  color: var(--gray-200);
}
.steps {
  margin: 10px 0;
  /* max-width: 80%; */
}
.steps li {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}
.steps li + li {
  margin-top: 15px;
}
.steps li span {
  font-weight: 600;
  font-size: 14px;
  color: var(--blue-500);
}
.steps p {
  font-size: 14px;
}

// instrucoes
.instrucoes {
  margin: 10px 0;
}
.instrucoes li {
  display: block;
  background: var(--gray-10);
  padding: 15px;
  border-radius: 5px;
  max-width: 79%;
}
@media screen and (max-width: 768px) {
  .instrucoes li {
    max-width: 100%;
  }
}
.instrucoes li p {
  font-size: 13px;
  line-height: 1.5;
}
.instrucoes li + li {
  margin-top: 15px;
}
.status {
  margin-top: 10px;
  display: inline-block;
  background: var(--gray-50);
  color: var(--old-800);
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 4px;
}

.status.ativada {
  background: var(--primary-50);
  color: var(--old-500);
}
.status + .status {
  margin-left: 15px;
}
@media screen and (max-width: 768px) {
  .status {
    display: block;
  }
  .status + .status {
    margin: 0;
    margin-top: 10px;
  }
}
.info-checkbox {
  display: inline;
}
#token {
  max-width: 500px;
}

.ga4 {
  height: 60px;
}

.custom-card-pixel {
  border: solid 0.5px var(--gray-50);
  border-radius: 10px;
  background-color: var(--gray-white);
  width: 100%;
  padding: 15px;
  margin: 5px;
}

.custom-control.custom-radio {
  background: transparent;
  padding: 0px;
  border-radius: 10px;
  cursor: pointer;
  width: 100%;
}
.custom-control.custom-checkbox {
  margin-top: -7px;
}
.info-checkbox.pixel-card {
  font-size: 14px;
}

.recomendation-chip {
  font-size: 12px;
  font-weight: 500;
  background-color: var(--primary-50);
  color: var(--primary-600);
  padding: 0px 10px 0px 10px;
  border: solid 1px transparent;
  border-radius: 5px;
}

.alinhamento-sem-descricao {
  margin-top: 4px;
}
</style>

<style>
.custom-align label {
  display: flex !important;
}
</style>
